import PropTypes from 'prop-types';

import {
  Airspeed,
  Altimeter,
  AttitudeIndicator,
  HeadingIndicator
} from 'react-typescript-flight-indicators';

// material
import { Box, Stack } from '@mui/material';

// utils
import { distance } from '../../common/utils/calculFunction';

// ----------------------------------------------------------------------

const pitch = (firstPosition, secondPosition) =>
  (Math.atan2(
    secondPosition.altitude - firstPosition.altitude,
    distance(firstPosition, secondPosition)
  ) *
    180) /
  Math.PI;

const roll = (firstPosition, secondPosition) => -5 * (secondPosition.course - firstPosition.course);
// ----------------------------------------------------------------------

FlightReviewIndicators.propTypes = {
  positions: PropTypes.array,
  indexDisplay: PropTypes.number
};
export default function FlightReviewIndicators({ positions, indexDisplay }) {
  return (
    <Box sx={{ ml: 3 }}>
      <Stack alignItems="center" direction="column">
        <Stack direction="row">
          <HeadingIndicator heading={positions[indexDisplay].course} showBox={false} size={160} />
          <Airspeed speed={positions[indexDisplay].speed} showBox={false} size={160} />
        </Stack>
        <Stack direction="row">
          <Altimeter
            altitude={Math.floor(positions[indexDisplay].altitude * 3.28084)}
            showBox={false}
            size={160}
          />
          <AttitudeIndicator
            roll={
              indexDisplay + 1 < positions.length
                ? roll(positions[indexDisplay], positions[indexDisplay + 1])
                : 0
            }
            pitch={
              indexDisplay + 1 < positions.length
                ? pitch(positions[indexDisplay], positions[indexDisplay + 1])
                : 0
            }
            showBox={false}
            size={160}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
